import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useCountUp } from "@/hooks/useCountUp";

function Stat({ value, label, suffix = "" }) {
  const [n, ref] = useCountUp(value);
  return (
    <div ref={ref} className="text-center" data-testid="social-stat">
      <div className="text-4xl font-bold tracking-tight text-neutral-900 sm:text-5xl">
        {n.toLocaleString()}{suffix}
      </div>
      <div className="mt-1 text-sm font-medium text-neutral-500">{label}</div>
    </div>
  );
}

export default function SocialProof() {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    api.get("/stats/public").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  if (!stats || stats.total_waitlist < 1) return null;

  return (
    <section className="border-y border-black/5 bg-white py-14" data-testid="social-proof">
      <div className="mx-auto grid max-w-5xl grid-cols-2 gap-8 px-6 md:grid-cols-4">
        <Stat value={stats.total_waitlist} label="People waiting" />
        <Stat value={stats.cities_count} label="Cities requested" />
        <Stat value={stats.states_count} label="States represented" />
        <Stat value={stats.total_providers} label="Businesses applied" />
      </div>
      <p className="mt-6 text-center text-sm font-medium text-neutral-400">Launching in our most requested cities first</p>
    </section>
  );
}
